import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';

/** Mirrors BE `com.qssi.ph10.features.config.workstation.dto.WorkstationOption`. */
export interface WorkstationOption {
  workstationId: string;
  description: string;
  /** True for PB's `(SYSTEM-DEFAULT)` row — picking it means "no workstation". */
  systemDefault: boolean;
}

/**
 * Option list for the workstation picker (ADR-0039 part A). Server state ⇒ TanStack Query.
 * `dbxx.workstation` changes about never, so a long stale time is right — but not `Infinity`,
 * because an admin adding a station via `/browse/workstation` should show up on the next
 * navigation rather than requiring a reload.
 */
export function useWorkstations() {
  return useQuery({
    queryKey: ['config', 'workstations'],
    queryFn: () => api<WorkstationOption[]>('/api/config/workstations'),
    staleTime: 5 * 60 * 1000,
  });
}
